<app-tb-menu
    #tbMenu
    *appEnv="'prod'; visible: false"
    [template]="automationMenu"
    xPosition="before"
    yPosition="above"
    class="rounded-lg"
>
    <ng-container
        trigger
        *ngTemplateOutlet="automationButton; context: { dark: dark, tbMenu }"
    ></ng-container>
</app-tb-menu>
<app-tb-menu
    #tbMenu
    *appEnv="'prod'; visible: true"
    [template]="automationExecute"
    xPosition="before"
    class="xsm:w-full sm:w-auto"
>
    <ng-container
        trigger
        *ngTemplateOutlet="automationButton; context: { dark: dark, tbMenu }"
    ></ng-container>
</app-tb-menu>

<ng-template #automationButton let-dark="dark" let-tbMenu="tbMenu" class="xsm:w-full sm:w-auto">
    <app-tb-tooltip-component
        *transloco="let tButtons; read: 'buttons'"
        [tooltip]="tButtons('automations')"
        [tooltipDisabled]="!displayTooltip"
        class="xsm:w-full sm:w-auto"
    >
        <app-tb-button
            [dark]="dark"
            appearance="text"
            class="xsm:w-full sm:w-auto xsm:rounded text-left xsm:bg-neutral2 sm:bg-transparent"
        >
            <div
                class="flex items-center rounded-lg h-7 -my-1 xsm:body-1 sm:body-2 text-left xsm:text-text sm:text-white"
                [class.bg-neutral4_20]="tbMenu.menuOpen"
            >
                <app-tb-icon icon="build" class="xsm:me-4 sm:me-2"></app-tb-icon>
                <span class="xsm:block sm:hidden lg:inline-flex xsm:body-1 sm:body-2 text-left"
                    >{{ tButtons('automations') }}
                </span>
            </div>
        </app-tb-button>
    </app-tb-tooltip-component>
</ng-template>
<!-- No design, final solution will be implemented later, for testing purposes -->
<ng-template #automationMenu>
    <div *transloco="let tButtons; read: 'buttons'" class="p-4">
        <p class="body-1 px-2 py-1 mb-2">
            <button (click)="createAutomation()">
                {{ tButtons('create_automation') }}
            </button>
        </p>
        <p class="body-1 px-2 py-1 mb-2">
            <app-tb-menu [template]="automationUpdate" xPosition="after">
                <button trigger>{{ tButtons('update_automation') }}</button>
            </app-tb-menu>
        </p>
        <p class="body-1 px-2 py-1 mb-2">
            <app-tb-menu [template]="automationDelete" xPosition="after">
                <button trigger>{{ tButtons('delete_automation') }}</button>
            </app-tb-menu>
        </p>
        <p class="body-1 px-2 py-1">
            <app-tb-menu [template]="automationExecute" xPosition="after">
                <button trigger>{{ tButtons('execute_automation') }}</button>
            </app-tb-menu>
        </p>
    </div>
</ng-template>
<ng-template #automationUpdate>
    @for (automation of automations$ | async; track automation.guid) {
        <div>
            <button (click)="updateAutomation(automation)">
                {{ automation.name }}
            </button>
        </div>
    }
</ng-template>
<ng-template #automationDelete>
    @for (automation of automations$ | async; track automation.guid) {
        <div>
            <button (click)="deleteAutomation(automation.guid)">
                {{ automation.name }}
            </button>
        </div>
    }
</ng-template>
<ng-template #automationExecute>
    @for (automation of executableAutomations$ | async; track automation.guid) {
        <div>
            <button (click)="executeAutomation(automation.guid)">
                {{ automation.name }}
            </button>
        </div>
    }
</ng-template>
